class Personalisation extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector(".js-personalisation-form");
    this.fields = this.querySelectorAll(".js-personalisation-field");
    this.show = this.querySelector(".js-personalisation-show");
    this.hide = this.querySelector(".js-personalisation-hide");
    this.quantity = document.querySelector(
      "product-info input[name='quantity']"
    );

    if (!this.fields.length) {
      return;
    }

    if (this.show) {
      this.show.addEventListener("click", this.showForm.bind(this));
    }
    if (this.hide) {
      this.hide.addEventListener("click", this.hideForm.bind(this));
    }

    if (this.quantity) {
      this.quantity.addEventListener("change", this.updateFields.bind(this));
    }

    this.optionSelect = document.querySelector(
      "product-info select[name='options[Personalise]']"
    );
    this.optionSelectWrapper = document.querySelector(
      "product-info variant-selects"
    );

    this.addFieldEvents();
  }
  showForm() {
    this.form.classList.add("active");
    this.show.classList.remove("button--secondary");
    this.hide.classList.add("button--secondary");

    if (this.optionSelect && this.optionSelectWrapper) {
      this.optionSelect.value = "Personalise";
      this.optionSelectWrapper.dispatchEvent(new Event("change"));
    }
  }

  hideForm() {
    this.form.classList.remove("active");
    this.show.classList.add("button--secondary");
    this.hide.classList.remove("button--secondary");

    if (this.optionSelect && this.optionSelectWrapper) {
      this.optionSelect.value = "No Personalisation";
      this.optionSelectWrapper.dispatchEvent(new Event("change"));
    }
  }

  updateFields() {
    const fieldCount = this.querySelectorAll(
      ".js-personalisation-field"
    ).length;

    if (this.quantity.value > fieldCount) {
      for (let i = fieldCount; i < this.quantity.value; i++) {
        this.addField();
      }
    } else {
      for (let i = fieldCount; i > this.quantity.value; i--) {
        this.removeField();
      }
    }
  }

  addField() {
    const node = this.querySelector(".js-personalisation-field");
    const clone = node.cloneNode(true);

    this.form.appendChild(clone);
    this.addFieldEvents();
  }

  removeField() {
    this.form.removeChild(this.form.lastChild);
    this.addFieldEvents();
  }

  addFieldEvents() {
    this.fields = this.querySelectorAll(".js-personalisation-field");
    this.fields.forEach((field) => {
      const label = field.querySelector(".js-field-count");
      const input = field.querySelector("input");
      if (input.hasAttribute("data-max-length")) {
        input.addEventListener("input", (e) => {
          const originalValue = input.value;
          const filteredValue = originalValue.replace(/[^A-Za-z0-9 .,!?'\-]/g, "");
        
          if (originalValue !== filteredValue) {
            alert(this.dataset.unsupportedCharactersMessage);
          }
          input.value = filteredValue;
        
          const length = input.value.length;
          const maxLength = input.getAttribute("data-max-length");
          label.textContent = length;

          if (length == maxLength) {
            e.preventDefault();
            return;
          }
        });
      }
    });

    this.addFieldHeadings();
  }

  addFieldHeadings() {
    this.fields = this.querySelectorAll(".js-personalisation-field");
    this.fields.forEach((field, index) => {
      const label = field.querySelector(".js-field-title");
      const input = field.querySelector("#personalisation");

      if (label) {
        label.remove();
      }

      if (this.fields.length > 1) {
        const title = document.createElement("label");
        title.classList.add("js-field-title");
        title.textContent = `${input.getAttribute(
          "data-personalisation-description"
        )} ${index + 1} ${input.getAttribute("data-personalisation")}`;
        const fieldWrapper = field.querySelector(".field");
        field.insertBefore(title, fieldWrapper);
      }
    });
  }
}

customElements.define("product-personalisation", Personalisation);
